import api from '@/api';
import type {ContentSubmissionResource} from './types';

const contentSubmissionsApi = {
  list: (
    gigId: string,
    params: {kind?: string; deliverableKind?: string} = {}
  ) =>
    api.get(`/paid_gigs/${gigId}/content_submissions`, {
      params: {
        ...(params.kind !== undefined && {kind: params.kind}),
        ...(params.deliverableKind !== undefined && {
          deliverable_kind: params.deliverableKind,
        }),
      },
    }) as Promise<{data: ContentSubmissionResource[]}>,

  children: (submissionId: string) =>
    api.get(
      `/content_submissions/${submissionId}/child_content_submissions`
    ) as Promise<{
      data: ContentSubmissionResource[];
    }>,
};

export default contentSubmissionsApi;
